import throttle from './throttle.js';

export default function Breakpoint() {
  const test = function () {
    return window
      .getComputedStyle(document.querySelector('body'), ':before')
      .getPropertyValue('content')
      .replace(/"/g, '');
  };

  let breakpoint = test();

  const event = new CustomEvent('breakpoint', {
      detail: this.breakpoint,
  });
  document.dispatchEvent(event);

  window.addEventListener(
      'resize',
      throttle(() => {
          const value = test();

          if (breakpoint !== value) {
              breakpoint = value;

              const event = new CustomEvent('breakpoint', {
                  detail: value,
              });
              document.dispatchEvent(event);
          }
      }, 50)
  );

  return {
    breakpoint,
  };
};
